import { apiClient } from '@/client'

const state = {
  regions: []
}

const getters = {
  regions: state => state.regions
}

const mutations = {
  SET_REGIONS: (state, payload) => {
    state.regions = payload
  }
}

const actions = {
  fetchRegions: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .getAllRegions()
        .then(payload => {
          commit('SET_REGIONS', payload)
        })
        .catch(reject)
    })
  }
}

export default { state, getters, mutations, actions }
